import { ModalWrapper } from "../../utils/fw"


export default {
	background: "https://assets.swoogo.com/uploads/full/1391436-615c65107235e.jpg",
	links: [
		{
			height: "7%",
			href: "/speaker-gallery",
			label: "Keynotes",
			left: "2.5%",
			top: "85.5%",
			width: "13.4%",
		},
		{
			elfsightPopupID: "",
			elfsightPopupTrigger: "",
			height: "7%",
			href: "/sponsor-speakers",
			label: "Sponsors",
			left: "83.5%",
			top: "85.5%",
			width: "13.4%",
		},
	],
	name: "member-speakers",
}
